import getSymbolFromCurrency from 'currency-symbol-map'
import { useCallback, useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router'

import { Card } from '../../../../components'
import { AccountItem } from '../../../../components/account-item/account-item'
import { SubMenu } from '../../../../components/sub-menu'
import { UserItemProps } from '../../../../components/user-item/user-item'
import { useAccounts, UseAccountsReturn } from '../../../../hooks/use-accounts'
import { MasaAccount } from '../../../../models'

interface UserProps {
    user: UserItemProps
}

export function UserAccounts({ user }: UserProps) {
    const history = useHistory()
    const location = useLocation()

    const handlePath = useCallback(
        (path: string) => history.push(path),
        [history],
    )

    const userDetailPages = useMemo(() => {
        const userAccounts = {
            children: 'Accounts',
            selected: location.pathname.includes(`/${user?.id}/accounts`),
            onClick: () => handlePath(`/masa/user/${user?.id}/accounts`),
        }

        const userDetail = {
            children: 'User detail',
            selected:
                location.pathname.includes(`/${user?.id}`) &&
                !location.pathname.includes(`/accounts`),
            onClick: () => handlePath(`/masa/user/${user.id}`),
        }

        return [userDetail, userAccounts]
    }, [location, handlePath, user])

    const handleRenderAccount = (account: MasaAccount, idx: number) => {
        return (
            <AccountItem
                className='rounded-md my-4'
                name={`${account?.provider} - ${
                    account.type === 'CRYPTO'
                        ? getSymbolFromCurrency(
                              account?.amount?.currency ?? ' ',
                          ) ?? account?.amount?.currency
                        : account?.amount?.currency
                } ${
                    account.type === 'CRYPTO' ? account?.amount?.value ?? 0 : ''
                }`}
                iconName={account?.amount?.currency ?? ''}
                lastUpdatedOne={new Date((account as any).lastUpdated)}
                balanceInfo={{
                    current:
                        account?.amount?.fiatValue ??
                        account?.amount?.value ??
                        0,
                    isoCurrencyCode:
                        getSymbolFromCurrency(
                            account?.amount?.fiatCurrency ?? 'usd',
                        ) ?? ' ',
                }}
                key={`account-${idx}`}
                isCrypto
            />
        )
    }

    const { accounts, getAdminAccounts } = useAccounts({
        id: `${user?.id}`,
    }) as UseAccountsReturn

    useEffect(() => {
        getAdminAccounts()
    }, [getAdminAccounts])

    return (
        <div className='flex flex-col gap-8 p-8 overflow-hidden' style={{}}>
            <SubMenu options={userDetailPages} />
            <Card className='flex-1 overflow-y-scroll'>
                <h1>Accounts</h1>
                {accounts.map((account, index) =>
                    handleRenderAccount(account, index),
                )}
            </Card>
        </div>
    )
}
